module.exports = __webpack_public_path__ + "img/3-2.17ea5c9d.svg";